import { getUserFacingErrorText } from "../../../../../utils/userFacingError";

/**
 * Kept for the existing callers. It delegates to the shared helper, so raw
 * server or network text never reaches the screen (wave 1, Oct 19 2026).
 */
export const getOperationErrorMessage = (
  error: unknown,
  fallback: string
): string => getUserFacingErrorText(error, fallback);

export const downloadCsv = ({
  csv,
  fileName,
}: {
  csv: string;
  fileName: string;
}) => downloadTextFile({ text: csv, fileName, type: "text/csv;charset=utf-8" });

export const downloadTextFile = ({
  text,
  fileName,
  type,
}: {
  text: string;
  fileName: string;
  type: string;
}) => {
  const blob = new Blob([text], { type });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");

  anchor.href = url;
  anchor.download = fileName;
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
};
export { PRESERVE_ERROR_FOR_CALLER_CONTEXT } from "../../../../../utils/apolloErrorPolicy";
